const translations = {
  'project.title': 'Projetos',
  'project.edit': 'Editando projeto',
  'project.new': 'Novo projeto',
  'project.create': 'Criando projeto',
  'project.cloning': 'Clonando projeto',
  'project.cloning.subtitle': 'Essa ação irá criar um novo projeto com os mesmos dados do projeto',
  'project.remove.confirmation': 'Certeza que deseja remover?',
  'project.remove.success': 'Projeto removido com sucesso!',
  'project.remove.error': 'Ocorreu um erro ao remover!',
  'project.form.field.name': 'Nome',
  'project.form.field.color': 'Cor',
  'project.form.field.icon': 'Ícone',
  'project.list.item.action.edit': 'Editar',
  'project.list.item.action.remove': 'Remover',
  'project.list.item.new.project': 'Novo projeto',
  'project.templates.createNew': 'Criar um novo',
  'project.templates.newProjectDescription': 'Novo projeto.',
  'project.templates.new': 'Novo',
  'project.templates.templates': 'Templates',
  'project.templates.selectTemplate': 'Selecione um template'
}

export default translations
